// extracted by mini-css-extract-plugin
export default {"container":"TermsOfUse_page_container__ucOog","wrapper":"TermsOfUse_page_wrapper__+FHsG","mainTitle":"TermsOfUse_page_mainTitle__kLt2m"};